import { Page as Component } from "~/components/specifics/admin/Page";

export function Page() {
	return <Component />;
}
